/**
 * Removes all categories from the elements array which are either empty by default or all of the contained options have been filtered out
 */
export function parseCategories(elements) {
  let hasItemSinceLastCategoryIndex = false;
  let hasCategories = false;
  const parsedElements = elements.reverse().map(option => {
    if (option.type === 'CATEGORY') {
      hasCategories = true;
      if (hasItemSinceLastCategoryIndex) {
        hasItemSinceLastCategoryIndex = false;
        return option;
      }
      hasItemSinceLastCategoryIndex = false;
      return {
        ...option,
        filtered: true
      };
    }
    if (!option.filtered) {
      hasItemSinceLastCategoryIndex = true;
    }
    return option;
  }).reverse();
  return {
    elements: parsedElements,
    hasCategories
  };
}